import ProviderPageRightPart from '../../../components/ProviderPage/ProviderPageRightPart/ProviderPageRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(ProviderPageRightPart);
